module.exports = __webpack_public_path__ + "pc/img/img11.7a5f983.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/teachers/img11.png
// module id = D8Z1
// module chunks = 3